var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSipConnect = function SvgSipConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sip-connect_svg__a)",
    stroke: "#F7F7F7",
    strokeWidth: 1.882,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.198 7.802 6.44-6.192M12.198 1.362h6.44v6.44",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 2.747a.99.99 0 0 1 .865.51l1.212 2.182a.99.99 0 0 1 .02.924L6.38 8.698s.338 1.74 1.754 3.156c1.416 1.416 3.15 1.748 3.15 1.748l2.334-1.167a.99.99 0 0 1 .925.02l2.189 1.217a.99.99 0 0 1 .51.866v2.513c0 1.28-1.19 2.204-2.402 1.795-2.491-.84-6.357-2.44-8.808-4.89-2.45-2.451-4.05-6.317-4.89-8.808-.41-1.213.515-2.401 1.795-2.401h2.512Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sip-connect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSipConnect;